import { render, staticRenderFns } from "./NotasNivel1.vue?vue&type=template&id=26a0314c"
import script from "./NotasNivel1.vue?vue&type=script&lang=js"
export * from "./NotasNivel1.vue?vue&type=script&lang=js"
import style0 from "./NotasNivel1.vue?vue&type=style&index=0&id=26a0314c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports